import { Dialog } from 'primereact/dialog';
import React from 'react';
import IconCloseFull from '../images/IconCloseFull.jsx';
import { highlightFileContent } from '../../utils/highlight.js';

const FilePreview = React.memo(({ visible, setVisible, file, setSelectedFile, search }) => {
    const hideDialog = () => {
        setVisible(false);
        setSelectedFile(null);
    };

    const renderFilePreview = () => {
        const extension = file?.extension?.toLowerCase();
        if (!file?.url) return <p className='text-sm text-theme1-primary'>Loading preview...</p>;

        if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg', 'tif', 'tiff', 'heic', 'heif'].includes(extension)) {
            return <img src={file.url} alt={file?.title} className='w-full h-auto rounded-lg' />;
        } else if (['mp3', 'wav'].includes(extension)) {
            return (
                <audio controls className='w-full rounded-2xl bg-theme1-cardStroke'>
                    <source src={file.url} type={`audio/${extension}`} />
                    Your browser does not support the audio element.
                </audio>
            );
        } else if (['mp4', 'avi', 'webm'].includes(extension)) {
            return (
                <video controls className='w-full rounded-lg'>
                    <source src={file.url} type={`video/${extension}`} />
                    Your browser does not support the video element.
                </video>
            );
        } else if (file?.content) {
            return (
                <p className='text-sm whitespace-pre-wrap overflow-y-auto max-h-[500px]'>
                    {search && search !== '' ? highlightFileContent(search, file.content) : file.content}
                </p>
            );
        } else {
            return <p className='text-sm text-theme1-primary'>Preview not available for this file type.</p>;
        }
    };

    if (!visible) return null;

    return (
        <Dialog
            className='rounded-4xl'
            visible={visible}
            style={{ width: '400px' }}
            breakpoints={{ '420px': '320px' }}
            onHide={hideDialog}
            content={() => (
                <div className='flex flex-col px-6 py-8 pt-12 bg-white rounded-4xl'>
                    <button onClick={hideDialog} className='absolute top-6 right-6'>
                        <IconCloseFull className='fill-theme1-text5' />
                    </button>
                    <h3 className={'font-bold text-2xl mb-4 break-words overflow-hidden'}>{file?.title}</h3>
                    {renderFilePreview()}
                </div>
            )}
        ></Dialog>
    );
});

FilePreview.displayName = 'FilePreview';

export default FilePreview;
